import { Link } from "react-router-dom";
import Typography from "../components/v2/Typography";
import Button from "../components/v2/Button";
import { ArrowRight, ArrowRightCircle } from "lucide-react";
import ServicesHeader from "../atoms/ServicesHeader";
import ContactSection from "../atoms/Contact";
import BlogSection from "../atoms/BlogPreview";
import Footer from "../atoms/Footer";

const ServiceShowcase = ({ title, description1, description2, imageUrl, buttonText1, buttonLink1, buttonText2, buttonLink2 }) => {
    return (
        <section className="service-showcase left-aligned">
            <div className="inner">
                <div className="service-image">
                    <img src={imageUrl} alt={title} />
                </div>
                <div className="service-content">
                    <div className="service-text">
                        <div className="service-heading">
                            <Typography variant="h1">{title}</Typography>
                        </div>
                        <div className="service-para">
                            <Typography variant="para">{description1}</Typography>
                            <Typography variant="para">{description2}</Typography>
                        </div>
                    </div>
                    <div className="service-controls">
                        {buttonText1 && (
                            <Button variant='primary' isLink linkProps={{ to: buttonLink1 }}>
                                <Typography variant={'button'}>{buttonText1}</Typography>
                            </Button>
                        )}
                        {buttonText2 && (
                            <Button variant='secondary' isLink linkProps={{ to: buttonLink2 }}>
                                <Typography variant={'button'}>{buttonText2}</Typography>
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};


const ServiceShowcaseR = ({ title, description1, description2, imageUrl, buttonText1, buttonLink1, buttonText2, buttonLink2 }) => {
    return (
        <section className="service-showcase right-aligned">
            <div className="inner">
                <div className="service-image">
                    <img src={imageUrl} alt={title} />
                </div>
                <div className="service-content">
                    <div className="service-text">
                        <div className="service-heading">
                            <Typography variant="h1">{title}</Typography>
                        </div>
                        <div className="service-para">
                            <Typography variant="para">{description1}</Typography>
                            <Typography variant="para">{description2}</Typography>
                        </div>
                    </div>
                    <div className="service-controls">
                        {buttonText1 && (
                            <Button variant='primary' isLink linkProps={{ to: buttonLink1 }}>
                                <Typography variant={'button'}>{buttonText1}</Typography>
                            </Button>
                        )}
                        {buttonText2 && (
                            <Button variant='secondary' isLink linkProps={{ to: buttonLink2 }}>
                                <Typography variant={'button'}>{buttonText2}</Typography>
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};


const Contact = () => {
    return (
        <>
            <ServicesHeader active="/services" />
            <ContactSection />
            <BlogSection />
        </>
    );
};

export default Contact;